module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-solid-rounded-IYSBBSWN.woff2?fc3e058f3a4c7819b24e3b51736a510e";